module.exports = __webpack_public_path__ + "assets/img/llthree.0c21a2f9.png";